export const Color = {
    brand_green: "#d62a8c",
    white: "#ffffff",
    black: "#180529",
    light_black: "#462365",
    dark_black: "#310a53",
    grey: "#6d5c80",
    pink: "#ff014f",
    orange: "#ff8a00",
    red: "#ff014f",

    dark_grey: "#462365",
    slate_grey: "#310a53",
    soft_grey: "#310a53", //
    black_grey: "#462365",

    dark_green: "#001b01",
    black_green: "#001000",
    middle_grey: "#484848",
    smoke_grey: "#cacaca",
    lime_green: "#d2f800",
    silver_grey: "#5c5c5c",


    vip_yellow: "#f9c600",
    vip_purple: "#aa9aca",
    vip_blue: "#74adb3",

    yellow: "#ffff00",
    pear: "#d5ec37",
    inchWorm: "#7aec37",

    transparent: "transparent"
};